import React from "react";
import { Link } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";

import img1 from "../images/IMG_12413_VSCO.jpg";
import img2 from "../images/DSC07925_VSCO.jpg";
import img3 from "../images/DSC06151_VSCO.jpg";
import img4 from "../images/DSC01190_VSCO_2.jpg";
import ebookImage from "../images/background.png";

const Home: React.FC = () => {

  const promise = useReveal();
  const services = useReveal();
  const portfolio = useReveal();
  const ebook = useReveal();
  const cta = useReveal();

  return (
    <div className="bg-[#f5f3ef] text-[#1a1a1a] font-sans">

      {/* HERO */}

      <section className="h-screen relative flex items-center overflow-hidden">

        <img
          src={img3}
          loading="eager"
          className="absolute w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/30"></div>

        <div className="relative max-w-6xl px-10 text-white">

          <p className="text-sm mb-4 opacity-80 animate-fadeUp">
            Margaux Silverio • Community Manager
          </p>

          <h1 className="text-6xl md:text-7xl font-light leading-tight max-w-3xl animate-fadeUp delay-200">
            Je capture l’essence de ton business
            <br />
            pour faire rayonner ton univers de marque.
          </h1>

          <p className="mt-6 max-w-xl text-lg text-white/80 animate-fadeUp delay-300">
            Des photos authentiques et impactantes pour valoriser ton activité,
            créer du contenu de qualité et développer ta présence sur les réseaux.
          </p>

          <div className="flex gap-4 mt-8 flex-wrap animate-fadeUp delay-500">

            <Link
              to="/services"
              className="bg-white text-black px-6 py-3 rounded-full hover:scale-105 transition"
            >
              Découvrir mes services
            </Link>

            <Link
              to="/portfolio"
              className="border border-white px-6 py-3 rounded-full hover:bg-white hover:text-black transition"
            >
              Voir mon portfolio
            </Link>

          </div>

        </div>

      </section>


      {/* PROMESSE */}

      <section
        ref={promise.ref}
        className={`max-w-6xl mx-auto px-10 py-32 grid md:grid-cols-2 gap-16 items-center transition-all duration-700 will-change-transform
        ${promise.visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      >

        <div>

          <p className="text-sm text-neutral-500 mb-4">
            Ta vision, mon objectif
          </p>

          <h2 className="text-5xl font-light leading-tight">
            Des visuels authentiques
            pour révéler l’identité
            de ton business.
          </h2>

        </div>

        <p className="text-neutral-600 leading-relaxed">
          Passionnée par la création de contenu depuis plusieurs années,
          j’accompagne les entrepreneuses et entreprises dans la mise en
          valeur de leur univers à travers des photos authentiques.
          <br /><br />
          Mon approche repose sur trois piliers : authenticité, stratégie, créativité.
        </p>

      </section>


      {/* SERVICES */}

      <section
        ref={services.ref}
        className={`max-w-4xl mx-auto px-10 pb-32 grid md:grid-cols-2 gap-8 transition-all duration-700
        ${services.visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      >

        {[img2, img1].map((img, i) => (

          <div
            key={i}
            className="group relative h-[620px] rounded-xl overflow-hidden cursor-pointer"
          >

            <img
              src={img}
              loading="lazy"
              className="absolute w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />

            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition"></div>

            <div className="absolute top-6 left-6 text-white pr-4">

              <h3 className="text-2xl  mb-2">
                {i === 0 && `Shooting "One Shot"`}
                {i === 1 && "Accompagnements Instagram"}
              </h3>

              <p className="text-sm text-white/80 max-w-xs">
                {i === 0 && "Un format simple, flexible et pensé pour t’offrir un contenu authentique et impactant, sans prise de tête."}
                {i === 1 && "Des accompagnements pensés pour développer ton compte et ta visibilité."}
              </p>

            </div>

          </div>

        ))}

      </section>

      {/* EBOOK */}

        <section
          ref={ebook.ref}
          className={`max-w-6xl mx-auto px-10 py-32 grid md:grid-cols-2 gap-8 transition-all duration-700
          ${ebook.visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
        >

          <img
            src={ebookImage}
            loading="lazy"
            className="w-full h-[400px] object-cover rounded-xl shadow-xl hover:scale-[1.02] transition duration-700"
          />

          <div>

            <p className="text-neutral-500 mb-4">
              E-book
            </p>

            <h2 className="text-5xl font-light mb-8">
              Ton guide pour créer une identité visuelle forte
            </h2>

            <p className="text-neutral-600 mb-6">
              Découvre les secrets pour construire une image de marque cohérente et mémorable.
            </p>

            <a
              href="https://buy.stripe.com/7sY14o6zA2rC1YFazKaR200"
              className="inline-block bg-black text-white px-8 py-4 rounded-full hover:scale-105 transition"
              target="_blank"
            >
              Télécharger l'e-book
            </a>

          </div>
        </section>

      {/* PORTFOLIO */}

      <section
        ref={portfolio.ref}
        className={`max-w-7xl mx-auto px-10 py-32 grid md:grid-cols-2 gap-20 items-center transition-all duration-700
        ${portfolio.visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      >

        <div>

          <p className="text-neutral-500 mb-4">
            Portfolio
          </p>

          <h2 className="text-5xl font-light mb-8">
            Des univers de marque
            capturés avec authenticité.
          </h2>

          <Link
            to="/portfolio"
            className="inline-block bg-black text-white px-8 py-4 rounded-full hover:scale-105 transition"
          >
            Voir le portfolio
          </Link>

        </div>

        <img
          src={img4}
          loading="lazy"
          className="w-full h-[800px] object-cover rounded-xl shadow-xl hover:scale-[1.02] transition duration-700"
        />

      </section>


      {/* CTA */}

      <section
        ref={cta.ref}
        className={`text-center py-32 px-10 transition-all duration-700
        ${cta.visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      >

        <h2 className="text-5xl font-light mb-6">
          Parlons de votre projet
        </h2>

        <p className="text-neutral-600 mb-10">
          Créons ensemble des visuels qui feront
          rayonner votre marque.
        </p>

        <Link
          to="/contact"
          className="bg-black text-white px-10 py-5 rounded-full hover:scale-105 transition"
        >
          → Parlons de votre projet
        </Link>

      </section>

    </div>
  );
};

export default Home;
